import { render, staticRenderFns } from "./send_bill.vue?vue&type=template&id=143efa26&scoped=true&"
import script from "./send_bill.vue?vue&type=script&lang=js&"
export * from "./send_bill.vue?vue&type=script&lang=js&"
import style0 from "./send_bill.vue?vue&type=style&index=0&id=143efa26&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143efa26",
  null
  
)

export default component.exports